/**
 * 复制到粘贴板方法
 * clipboard.js
 * https://github.com/zenorocha/clipboard.js
 * 使用案例参见： @/views/jt-ui-demo/copy-text
 *
 */
import ClipboardJS from 'clipboard'
import { VueConstructor } from 'vue'

function emptyError (trigger: Element, text: string, clearSelection: () => void): ClipboardJS.Event | { message?: string } {
  return {
    action: 'EmptyError',
    text,
    trigger,
    clearSelection,
    message: '不能复制空字符串',
  }
}
export const copyText = (text: string) => {
  return new Promise((resolve, reject) => {
    const btn = document.createElement('button')
    if (text === '') {
      reject(emptyError(btn, text, () => {}))
      return
    }
    const clipboard = new ClipboardJS(btn, {
      text: function() {
        return text
      }
    })
    clipboard.on('success', function(e) {
      clipboard.destroy()
      resolve(e)
    })
    clipboard.on('error', function(e) {
      clipboard.destroy()
      reject(e)
    })
    document.body.appendChild(btn)
    btn.click()
    document.body.removeChild(btn)
  })
}

// 全局引入
const JClipboard = {
  install(Vue: VueConstructor) {
    Vue.prototype.$copyText = copyText
  }
}
export default JClipboard
